export default "__VITE_ASSET__CW4traax__"